var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg30(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1091_5865)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.2888 14.9562C1.27783 14.9597 1.26825 14.9665 1.26145 14.9758C1.25464 14.985 1.25098 14.9962 1.25098 15.0077C1.25098 15.0192 1.25464 15.0303 1.26145 15.0396C1.26825 15.0489 1.27783 15.0557 1.2888 15.0591L5.53087 17.861L6.7457 12.1445L1.2888 14.9562Z",
    fill: "#E72511"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.428 12.1392H25.3504C25.2842 12.1433 25.2193 12.1599 25.1593 12.1881L19.771 14.9607C19.722 14.9607 19.7171 15.0293 19.771 15.0635L23.9396 17.8067C23.9967 17.8387 24.0604 17.8571 24.1258 17.8606H25.1985C25.2573 17.8606 25.2622 17.8606 25.1985 17.8067L20.9368 15.0048L26.428 12.1881C26.4721 12.1637 26.4672 12.1392 26.428 12.1392Z",
    fill: "#F08300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1108 12.1392H16.6308L15.416 17.8606H22.8862C22.945 17.8606 22.9499 17.8606 22.8862 17.8067L18.6343 15.0048L24.0961 12.1881C24.1745 12.1637 24.1696 12.1392 24.1108 12.1392Z",
    fill: "#E72511"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7055 12.1392H27.6327C27.5664 12.1424 27.5014 12.159 27.4417 12.1881L22.0533 14.9607C22.0044 14.9607 22.0044 15.0293 22.0533 15.0635L26.2268 17.8067C26.2819 17.8392 26.3442 17.8577 26.4081 17.8606H27.4857C27.5396 17.8606 27.5494 17.8606 27.4857 17.8067L23.229 15.0048L28.6957 12.1881C28.7642 12.1637 28.7593 12.1392 28.7055 12.1392Z",
    fill: "#FABE00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7832 8.39711H6.18787C5.76918 8.37687 5.35664 8.50398 5.02194 8.75635C4.68724 9.00871 4.45156 9.37037 4.35585 9.77847C4.31238 9.97238 4.32629 10.1748 4.39587 10.3609C4.46546 10.547 4.58771 10.7089 4.74772 10.8267L11.0716 15.0002L23.8077 8.44608C23.8419 8.41669 23.8371 8.39711 23.7832 8.39711Z",
    fill: "#E72511"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9909 21.5492L11.0764 15L2.97928 19.1784C2.77478 19.2857 2.59475 19.4343 2.45057 19.6147C2.3064 19.7952 2.2012 20.0035 2.14164 20.2267C1.97509 20.9859 2.40126 21.6031 3.38585 21.6031H20.9812C21.0399 21.6031 21.0399 21.5786 20.9909 21.5492Z",
    fill: "#E72511"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1091_5865"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.5,
    height: 13.2063,
    fill: "white",
    transform: "translate(1.25 8.39697)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg30);
export default __webpack_public_path__ + "static/media/우체국-30.fbefc1ac747c4ca238799bc433c643af.svg";
export { ForwardRef as ReactComponent };